import { takeLatest } from 'redux-saga/effects';
import {
  getAwardListSuccess, getAwardListFail,
  getAwardDetailsSuccess, getAwardDetailsFail
} from './awardState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/awards');
const redirectData = { route:'/console/awards', mode:'list', recordId:0 };
const modelName = 'Award';
const modelId = 'awd_id';

function* getAwardList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getAwardListSuccess,
    getAwardListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getAwardDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getAwardDetailsSuccess,
    getAwardDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doAwardCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getAwardDetailsSuccess,
    getAwardDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

function* doAwardUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getAwardDetailsSuccess,
    getAwardDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    UPDATING_MSG
  );
}

function* doAwardDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getAwardDetailsSuccess,
    getAwardDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* awardSaga() {
  yield takeLatest('award/getAwardList', getAwardList);
  yield takeLatest('award/getAwardDetails', getAwardDetails);
  yield takeLatest('award/doAwardCreate', doAwardCreate);
  yield takeLatest('award/doAwardUpdate', doAwardUpdate);
  yield takeLatest('award/doAwardDelete', doAwardDelete);
}

export default awardSaga;
